import { useQuery } from '@tanstack/react-query'

import { getCardTransactions } from '@src/api'
import { DefaultApiGetCardTransactionsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchCardTransactions = (
  params: DefaultApiGetCardTransactionsRequest
) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading } = useQuery({
    enabled:
      !!params.userAccountId && !!params.merchantId && !!params.toYearMonth,
    queryFn: () => getCardTransactions(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_CARD_TRANSACTIONS,
      params.userAccountId,
      params.merchantId,
      params.fromYearMonth,
      params.toYearMonth,
    ],
  })

  return { data, isError, isLoading }
}
